import React, { useState, useEffect } from 'react';
import stilePulsanti from '../../interfaccia/stilePulsanti';
import SettingBooleano from '../../statistiche/SettingBooleano';
import axios from 'axios';
import apiUrl from '../../Apiurl';
import { LineChart } from "@mui/x-charts/LineChart";
import { LineChartSkeleton } from "../../interfaccia/loading";

function StatSpedPaesi({
  mobile,
  token
}) {
  
    const {
        buttonClassesWhite,
        buttonClassesGreen,
        buttonClassesOrange
    } = stilePulsanti


    const [settings, setSettings] = useState({
        series: {},        
        anni: 3,
        robaDaSommare: "importo",
        stack: 1,
        scope: "all" // amazon | prestashop | all
    })

    const [availableSeries, setAvailableSeries] = useState([]);

    // Logic to fetch available series (Top 10 countries) when core settings change (anni, robaDaSommare, scope)
    // Actually, ContainerLoaderCharts does the fetching. 
    // We need to intercept the data to set the toggles OR fetch it ourselves.
    // Given the structure of 'ContainerLoaderCharts', it accepts a 'query'.
    // If we want to render toggles for "Top 10", we need to know what they are. 
    // The backend returns { dataSet: [], series: [] }.
    // ContainerLoaderCharts probably expects the array directly or handles { dataSet }.
    // Let's assume ContainerLoaderCharts expects the data array directly or a specific format.
    // If I check 'StatSpedMarketplaces', it passes 'settings' to ContainerLoaderCharts. 
    // The chart component there likely uses 'settings.series' to filter keys.
    // BUT here the keys are dynamic. 
    
    // STRATEGY: 
    // We need to fetch the data here first to get the 'series' list (the top 10 countries).
    // Then we populate 'settings.series' with { 'Italy': true, 'France': true ... }.
    // Then we pass this to ContainerLoaderCharts.
    // BUT ContainerLoaderCharts *also* fetches data. This would be double fetching.
    
    // Let's implement a standalone fetch here and pass "data" to a generic Chart component, 
    // OR look at how ContainerLoaderCharts works.
    // 'ContainerLoaderCharts' likely acts as a "Smart Container" that fetches. 
    
    // To save time and follow the requested "replica il funzionamento", let's try to fit into the pattern.
    // StatSpedMarketplaces has HARDCODED keys. 
    // StatSpedPaesi has DYNAMIC keys.
    
    // Workaround: 
    // Fetch the data in THIS component.
    // Extract the series list. 
    // Manage state here.
    // Don't use ContainerLoaderCharts for the *fetching*, but use the *Chart* component it wraps?
    // Or just use ContainerLoaderCharts and let it double fetch? No, that's bad.
    
    // Let's check ContainerLoaderCharts quickly? No tool calls left in this block.
    // I will write a component that fetches its own data, manages standard state, and renders the charts using the libraries directly or via a simpler wrapper if available. 
    // 'StatSpedMarketplaces' uses the URL param to fetch. 
    
    // Proposed solution:
    // 1. useEffect on [anni, robaDaSommare, scope] -> Fetch /linesSpedizioniPaesi
    // 2. On response -> setChartData(res.dataSet), setAvailableSeries(res.series)
    // 3. Initialize settings.series with all true if not set.
    // 4. Render standard controls + Dynamic Series Toggles.
    // 5. Pass filtered data to a LineChart (I can copy the LineChart render logic from DashboardOrdini or use a generic one if I knew it).
    // Since I don't see 'LineChart' exported cleanly, I will use `ContainerLoaderCharts` BUT I will pass `data` directly if it supports it? 
    // Looking at its props: query, titolo, tipo, displayTitolo, settings.
    // If I cannot pass data, I must use the `query`.
    
    // Alternative: The chart component handles the response. 
    // If I use ContainerLoaderCharts, I can't generate the toggles *before* the chart loads.
    // But maybe I can render the toggles *after* the chart loads if I can lift state up? 
    // Probably too complex.
    
    // I will implement a custom fetch loop here. It's safer.
    
    const [chartData, setChartData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // Palette similar to XmesiYmarketplaces but extended
    const PALETTE = [
        "#ff9800", "#009688", "#1565c0", "#9c27b0", "#b71c1c",
        "#e91e63", "#8bc34a", "#00bcd4", "#795548", "#607d8b",
        "#ffeb3b", "#3f51b5"
    ];

    const [seriesColors, setSeriesColors] = useState({});

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                 const params = new URLSearchParams({
                    anni: settings.anni,
                    robaDaSommare: settings.robaDaSommare,
                    scope: settings.scope
                });
                const res = await axios.get(`${apiUrl}/contab/charts/linesSpedizioniPaesi?${params.toString()}`, 
                    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
                );
                
                setChartData(res.data.dataSet);
                
                // Assign colors stable based on index
                const incomingSeries = res.data.series || [];
                const newColors = {};
                incomingSeries.forEach((s, idx) => {
                    newColors[s] = PALETTE[idx % PALETTE.length];
                });
                newColors['other'] = "#9e9e9e"; // Fixed grey for others

                setSeriesColors(newColors);

                // Initialize toggles for new series if explicitly new (maintain state if just refresh?)
                // For simplicity, we can just merge.
                
                setSettings(prev => {
                     // Keep existing toggles if they exist? No, series might change if scope changes.
                     // But if scope changes, we should probably reset series.
                     const nextSeries = {};
                     incomingSeries.forEach(s => {
                         nextSeries[s] = true;
                     });
                     nextSeries['other'] = prev.series['other'] ?? false; 
                     return {
                        ...prev,
                        series: nextSeries
                     };
                });
                
                setAvailableSeries(incomingSeries);

            } catch (err) {
                console.error("Error fetching stats paesi", err);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [settings.anni, settings.robaDaSommare, settings.scope, token]);

    return (
        <div className='sfondoBiancoTema tc pa3'>
        <h3>Ordini per Paese: Top 10</h3>
            <div className='flex flex-wrap items-center justify-between'>
                
                {/* SETTINGS BAR */}
                <div className='flex items-center mb2'>
                    <div>ultimi</div>
                    <input
                        type='number'
                        value={settings.anni}
                        onChange={(e)=>setSettings({...settings,anni:e.target.value})}
                        className={stilePulsanti.inputClassesRicercaOrizzontale}
                        min={1}
                        max={5}
                    />
                    <div className='mr3'>anni</div>
                </div>

                <div className='flex items-center mb2 mr3'>
                    <span className='mr2'>Canale</span>
                    <button onClick={()=>setSettings({...settings, scope: 'all'})} className={settings.scope === 'all' ? buttonClassesGreen : buttonClassesWhite}>Tutti</button>
                    <button onClick={()=>setSettings({...settings, scope: 'amazon'})} className={settings.scope === 'amazon' ? buttonClassesGreen : buttonClassesWhite}>Amazon</button>
                    <button onClick={()=>setSettings({...settings, scope: 'prestashop'})} className={settings.scope === 'prestashop' ? buttonClassesGreen : buttonClassesWhite}>PrestaShop</button>
                </div>

                <div className='flex items-center mb2 mr3'>
                    <span className='mr2'>Per importo / per quantità:</span>
                    <SettingBooleano 
                        value={settings.robaDaSommare}
                            trueButtonClass={buttonClassesOrange}
                            falseButtonClass={buttonClassesGreen}
                            trueElement={"importo"}
                            falseElement={"ordini"}
                            setTrue={()=>setSettings({...settings,robaDaSommare:"importo"})}
                            setFalse={()=>setSettings({...settings,robaDaSommare:"ordini"})}
                            customValueTrue={"importo"}
                            customValueFalse={"ordini"}
                    />
                </div>
                <div className='flex items-center mb2 mr3'>
                    <span className='mr2'>Stack / Linee:</span>
                    <SettingBooleano 
                        value={settings.stack}
                            trueButtonClass={buttonClassesOrange}
                            falseButtonClass={buttonClassesGreen}
                            trueElement={"stack"}
                            falseElement={"linee"}
                            setTrue={()=>setSettings({...settings,stack:1})}
                            setFalse={()=>setSettings({...settings,stack:0})}
                    />
                </div>
            </div>    

            {/* DYNAMIC SERIES TOGGLES WITH COLORS */}
            <div className='flex flex-wrap justify-center mb3'>
                 {(availableSeries || []).map((country) => {
                     const isActive = settings.series[country];
                     const color = seriesColors[country] || "#000";
                     return (
                         <button
                             key={country}
                             onClick={() => setSettings(prev => ({...prev,series:{...prev.series, [country]: !isActive}}))}
                             className={"ma1 pa2 pointer br2 b--none white f6"}
                             style={{
                                 backgroundColor: isActive ? color : '#eee',
                                 color: isActive ? '#fff' : '#333',
                                 border: isActive ? 'none' : '1px solid #ccc'
                             }}
                         >
                             {country}
                         </button>
                     );
                 })}
                 
                 {/* Altri Button */}
                 <button
                     onClick={() => setSettings(prev => ({...prev,series:{...prev.series, 'other': !settings.series['other']}}))}
                     className={"ma1 pa2 pointer br2 b--none white f6"}
                     style={{
                         backgroundColor: settings.series['other'] ? seriesColors['other'] : '#eee',
                         color: settings.series['other'] ? '#fff' : '#333',
                         border: settings.series['other'] ? 'none' : '1px solid #ccc'
                     }}
                 >
                     Altri
                 </button>
            </div>      
            
            {loading && (
                <LineChartSkeleton
                    tone="soft"
                    height={mobile ? 300 : 500}
                    seriesCount={Math.max(2, Math.min((availableSeries || []).length || 3, 4))}
                />
            )}
            
            {!loading && chartData && (
                 <ReusedLineChart 
                    dataset={chartData}
                    seriesKeys={availableSeries.concat('other')}
                    activeSeries={settings.series}
                    seriesColors={seriesColors}
                    stack={settings.stack}
                    metric={settings.robaDaSommare}
                    mobile={mobile}
                 />
            )}
        </div>
  )
}


function ReusedLineChart({ dataset, seriesKeys, activeSeries, seriesColors, stack, metric, mobile }) {
    
    // dataset is [{ year_month_combined: '2023-01', Italy: 100, France: 200, other: 50 }, ...]
    
    // Transform dataset Dates
    const finalData = dataset.map(row => {
         const date = new Date(`${row.year_month_combined}-01T00:00:00`);
         return {
             ...row,
             month: date
         }
    }).filter(r => !isNaN(r.month.getTime())).sort((a,b) => a.month - b.month);

    const valueFormatter = (v) => {
        if (metric === 'importo') return `${Number(v).toLocaleString('it-IT', {minimumFractionDigits: 2})} €`;
        return v;
    }

    const series = seriesKeys
        .filter(key => activeSeries[key])
        .map(key => ({
            dataKey: key,
            label: key === 'other' ? 'Altri' : key,
            valueFormatter,
            showMark: true,
            strokeWidth: 2,
            color: seriesColors[key],
            ...(stack ? { stack: "total", area: true, stackOffset: "none" } : {}),
            // Ensure no null values crash
            data: finalData.map(d => d[key] || 0) // Explicit data mapping not needed if using 'dataset' prop + dataKey, but we need to ensure data exists in row
        }));

    if (series.length === 0) return <div>Seleziona almeno un paese</div>

    return (
        <div style={{ width: '100%', height: mobile ? 300 : 500 }}>
             <LineChart
                dataset={finalData}
                xAxis={[{
                    dataKey: 'month',
                    scaleType: 'time',
                    valueFormatter: (v) => v ? new Date(v).toLocaleDateString("it-IT", { month: '2-digit', year: '2-digit' }) : ""
                }]}
                series={series}
                height={mobile ? 300 : 500}
                margin={{ left: 70, right: 40, top: 20, bottom: 50 }}
             />
        </div>
    )
}

export default StatSpedPaesi;
